import { render, staticRenderFns } from "./ServiciosImpagosLista.vue?vue&type=template&id=37cc6dc9&"
import script from "./ServiciosImpagosLista.vue?vue&type=script&lang=js&"
export * from "./ServiciosImpagosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports